import o from"styled-components";const t=o.div`
	position: absolute;
	border-radius: 20px;
	border: 1px solid ${({theme:o})=>o.border.black10};
	background-color: ${({theme:o})=>o.bg.general};
	box-shadow: 0 4px 12px 0 rgba(65, 65, 65, 0.16);
	padding: 16px;
	width: 374px;

	${({position:o})=>{const t=[];return void 0!==(null==o?void 0:o.bottom)&&t.push(`bottom: ${o.bottom};`),void 0!==(null==o?void 0:o.right)&&t.push(`right: ${o.right};`),void 0!==(null==o?void 0:o.top)&&t.push(`top: ${o.top};`),void 0!==(null==o?void 0:o.left)&&t.push(`left: ${o.left};`),t||"bottom: 0; right: 0; top: auto; left: auto"}};

	margin-bottom: 6px;
	box-sizing: border-box;
	z-index: 50000;
`,e=o.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`,i=o.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`,r=o.h1`
	margin: 0;
	font-weight: 400;
	color: ${({theme:o})=>o.text.title};
	font-size: ${({fontSize:o="14px"})=>o};
	text-transform: ${({textTransform:o="none"})=>o};
	font-family: "PP Formula";
`,n=o.p`
	margin: 0;
	color: ${({theme:o})=>o.text.text};
	font-size: 12px;
	text-transform: none;
	font-family: "PP Formula";
`,l=o.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 8px;
`;export{t as ColorPickerContainer,i as ColorPickerSection,e as ColorPickerSectionsContainer,l as ColorsContainer,n as SectionDescription,r as SectionHeading};
